{
  "title": "Faktiir",
  "number": "Nimero faktiir",
  "date": "Bés",
  "due_date": "Bés bu mujj",
  "customer": "Kiliyaan",
  "items_table": {
    "description": "Tekki",
    "quantity": "Limu",
    "unit_price": "Njëg bokk HT",
    "total": "Tollu HT"
  },
  "summary": {
    "subtotal_ht": "Tollu HT",
    "tva": "TVA (18%)",
    "total_ttc": "Tollu TTC"
  },
  "status": {
    "label": "Yoonu",
    "draft": "Bruyon",
    "issued": "Yonnee na",
    "paid": "Fey na",
    "cancelled": "Neenal na",
    "refunded": "Delloo na"
  },
  "actions": {
    "view": "Xool",
    "download_pdf": "Wàcce PDF",
    "print": "Imprimer",
    "send_email": "Yonnee ci email"
  },
  "company": {
    "legal_notice": "CIEDA SARL — Hann Mariste II, Ndakaaru, Senegaal",
    "ninea": "NINEA",
    "rc": "RC",
    "payment_terms": "Cëru fey : Fey ci waxtu komand bi"
  },
  "list": {
    "title": "Sama faktiir yi",
    "column_status": "Yoonu",
    "empty": "Amul faktiir",
    "empty_description": "Sa faktiir yi dinañu feeñ fii ginnaaw sa komand bu njëk bi"
  },
  "customer_page": {
    "title": "Sama faktiir yi",
    "empty_title": "Amul faktiir",
    "empty_message": "Sa faktiir yi dinañu feeñ fii ginnaaw sa jënd yi."
  },
  "admin": {
    "title": "Saytu faktiir yi",
    "column_number": "Nimero faktiir",
    "column_date": "Bés",
    "column_customer": "Kiliyaan",
    "column_total": "Tollu TTC",
    "column_status": "Yoonu",
    "column_actions": "Jëf yi",
    "filter_all": "Yépp",
    "filter_issued": "Yonnee na",
    "filter_paid": "Fey na",
    "filter_cancelled": "Neenal na",
    "search_placeholder": "Seet faktiir...",
    "pagination_of": "ci",
    "pagination_results": "nataal",
    "no_results": "Amul nataal",
    "no_results_description": "Amul faktiir bu baax ak li ngay seet."
  },
  "qr": {
    "scan_to_verify": "Skan ngir dëggal"
  }
}
